// extracted by mini-css-extract-plugin
export default {"module":"qbcSNK6qsrGA8SMlIzlg","header":"OBO_lYOW_MsBAnjj3Fyk","list":"KiHVFrgORHt4sEnIPDOX"};